import { ReactNode } from 'react';
import Footer from './Footer';
import Reveal from './redesign/Reveal';
export default function PageBasicTemplate({ children, title, sub_title }: { children: ReactNode; title: string; sub_title: string }) {
  return <><main id="main-content" tabIndex={-1}><header className="page-heading"><h1>{title}</h1>{sub_title && <p>{sub_title}</p>}</header><div className="page-content section-shell"><Reveal>{children}</Reveal></div></main><Footer /></>;
}
